import React, { useEffect, useState } from "react";
import { ColumnChart } from "../../../library/ColumnChart";
import AttendanceBreakdownChart from "../Charts/AttendanceBreakdownChart";
import SubjectChart from "../Charts/SubjectChart";

import { GetClassParticipants, GetOnlineClassGraphData } from "../../../../services/CourseService";

const Attendance = (props) => {
  const [graphData, setGraphData] = useState([])

  const AttendanceBreakdown = [
    { type: '0-20%', value: graphData?.sum_student_0_20 },
    { type: '20-40%', value: graphData?.sum_student_20_40 },
    { type: '40-60%', value: graphData?.sum_student_40_60 },
    { type: '60-80%', value: graphData?.sum_student_60_80 },
    { type: '80-100%', value: graphData?.sum_student_80_100 }
  ]



  useEffect(() => {
    getFirstGraphData();
    GetClassParticipants(props.subTab).then((res) => {
      props.setClassTitle(res.data.online_classes_participants.class_title)

      setGraphData(res.data)
    }).catch(err => {
      console.log(err);
    })
  }, []);
  
  const getFirstGraphData = async () => {
    try {
      await GetOnlineClassGraphData(props.uId, props.subTab);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const recordingData = [
    {
      type: "View",
      Students: graphData?.count_view,
    },
    {
      type: "Downloads",
      Students: graphData?.count_download,
    },
  ];
  const attendanceSummery = [
    {
      type: "Present",
      Students: graphData?.sum_student_present,
    },
    {
      type: "Partially Attended ",
      Students: graphData?.sum_student_partialy,
    },
    {
      type: "Absent",
      Students: graphData?.sum_student_absent,
    },
  ];
  const attendance = [
    {
      type: "Virtual",
      Students: graphData?.sum_student_online,
    },

    {
      type: "On Campus",
      Students: graphData?.sum_student_campus,
    },
  ];


  return (
    <>
      <div className="card-new card card-profile-info-card mb-30">
        <div className="">
          <div className="card-header">Graphs</div>
          <div className="card-body-inr card-body-info">
            <div className="graphs-info-box">
              <div className="row">
                <div className="col-md-4">
                  <div className="graphs-info-items">
                    <ColumnChart
                      data={attendanceSummery}
                      categoryKey="type"
                      valueKey="Students"
                      height={390}
                      title="Attendance Summary"
                      xAxisTitle="Attendance"
                      yAxisTitle="Total Students (In numbers)"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="graphs-info-items">
                    {graphData ? (
                      <ColumnChart
                        data={recordingData}
                        categoryKey="type"
                        valueKey="Students"
                        height={390}
                        title="Class Recording"
                        xAxisTitle="Recordings View/Downloads"
                        yAxisTitle="Total Students (In numbers)"
                      />
                    ) : "NA"}

                  </div>
                </div>
                <div className="col-md-4">
                  <div className="graphs-info-items">
                    <ColumnChart
                      data={attendance}
                      categoryKey="type"
                      valueKey="Students"
                      height={390}
                      title="Attendance Summary"
                      xAxisTitle="Attendance"
                      yAxisTitle="Total Students (In numbers)"
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-4">
                  <div className="graphs-info-items">
                    {/* <label>Pie</label> */}

                    <AttendanceBreakdownChart data={AttendanceBreakdown} />

                  </div>
                </div>

                <div className="col-md-4">
                  {graphData && graphData?.subjects ? <div className="graphs-info-items">
                    {/* <label>Pie</label> */}
                    <SubjectChart data={graphData.subjects} />
                  </div> : "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attendance;
